import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import Responsive from 'datatables.net-responsive';
import DoughnutChart from '../../components/charts/DoughnutChart';
import AreaChart from '../../components/charts/AreaChart';

DataTable.use(DT);
DataTable.use(Responsive);

const Earning: React.FC = () => {
    const [, setDtApi] = useState<any>(null);

    const options = useMemo(() => ({
        responsive: true,
        pageLength: 10,
        lengthChange: false,
        searching: true,
        dom: 'rtip',
        initComplete: (settings: any) => {
            const api = new DT.Api(settings);
            setDtApi(api);
        }
    }), []);

    const transactionsData = useMemo(() => [
        {
            icon: { type: 'icon', class: 'bi-currency-bitcoin', bgClass: 'bg-theme-1 theme-orange' },
            name: 'BitCoins',
            subtitle: '1 way trip',
            amount: '0.000015',
            currency: 'BTC',
            category: 'Traveling',
            categoryType: 'Work',
            status: 'Delivered',
            statusClass: 'text-bg-success',
            deliverTo: 'John Doe',
            address: '2356, Street-5, New York 4586, US',
            location: 'Lat: 5.678167, Long: 12.078613',
            locationNote: 'This can be a map also',
            payment: 'Paid',
            paymentClass: 'bg-green'
        },
        {
            icon: { type: 'image', src: asset('assets/img/adminuiux/image-1.jpg') },
            name: 'Starbucks',
            subtitle: '2 Coffee',
            amount: '6.00',
            currency: 'USD',
            category: 'Food',
            categoryType: 'Work',
            status: 'Delivered',
            statusClass: 'text-bg-success',
            deliverTo: 'John Doe',
            address: '2356, Street-5, New York 4586, US',
            location: 'Lat: 5.678167, Long: 12.078613',
            locationNote: 'This can be a map also',
            payment: 'Waiting',
            paymentClass: 'bg-theme-1 theme-blue'
        },
        {
            icon: { type: 'icon', class: 'bi-cup-hot', bgClass: 'bg-theme-1 theme-green' },
            name: 'Starbucks',
            subtitle: '2 Coffee',
            amount: '6.00',
            currency: 'USD',
            category: 'Food',
            categoryType: 'Work',
            status: 'Delivered',
            statusClass: 'text-bg-success',
            deliverTo: 'John Doe',
            address: '2356, Street-5, New York 4586, US',
            location: 'Lat: 5.678167, Long: 12.078613',
            locationNote: 'This can be a map also',
            payment: 'Waiting',
            paymentClass: 'bg-theme-1 theme-blue'
        },
        {
            icon: { type: 'image', src: asset('assets/img/adminuiux/image-4.jpg') },
            name: 'PetMall',
            subtitle: '12 Items',
            amount: '180.00',
            currency: 'USD',
            category: 'Grocery',
            categoryType: 'Home',
            status: 'Delivered',
            statusClass: 'text-bg-success',
            deliverTo: 'John Doe',
            address: '2356, Street-5, New York 4586, US',
            location: 'Lat: 5.678167, Long: 12.078613',
            locationNote: 'This can be a map also',
            payment: 'Unpaid',
            paymentClass: 'bg-red'
        },
        {
            icon: { type: 'icon', class: 'bi-basket', bgClass: 'bg-theme-1 theme-cyan' },
            name: 'EasyMall',
            subtitle: '12 Items',
            amount: '180.00',
            currency: 'USD',
            category: 'Grocery',
            categoryType: 'Home',
            status: 'Delivered',
            statusClass: 'text-bg-success',
            deliverTo: 'John Doe',
            address: '2356, Street-5, New York 4586, US',
            location: 'Lat: 5.678167, Long: 12.078613',
            locationNote: 'This can be a map also',
            payment: 'Unpaid',
            paymentClass: 'bg-red'
        },
        {
            icon: { type: 'icon', class: 'bi-flower1', bgClass: 'bg-theme-1 theme-red' },
            name: 'Zomaatos',
            subtitle: 'Meal',
            amount: '12.00',
            currency: 'USD',
            category: 'Food',
            categoryType: 'Work',
            status: 'Delivered',
            statusClass: 'text-bg-success',
            deliverTo: 'John Doe',
            address: '2356, Street-5, New York 4586, US',
            location: 'Lat: 5.678167, Long: 12.078613',
            locationNote: 'This can be a map also',
            payment: 'Paid',
            paymentClass: 'bg-green'
        },
        {
            icon: { type: 'image', src: asset('assets/img/adminuiux/image-3.jpg') },
            name: 'LeoCoin',
            subtitle: '1 way',
            amount: '0.000015',
            currency: 'BTC',
            category: 'Traveling',
            categoryType: 'Work',
            status: 'In-Progress',
            statusClass: 'text-bg-primary',
            deliverTo: 'John Doe',
            address: '2356, Street-5, New York 4586, US',
            location: 'Lat: 5.678167, Long: 12.078613',
            locationNote: 'This can be a map also',
            payment: 'Paid',
            paymentClass: 'bg-green'
        },
        {
            icon: { type: 'icon', class: 'bi-car-front', bgClass: 'bg-theme-1 theme-grey' },
            name: 'UserCars',
            subtitle: 'Round Trip',
            amount: '251.00',
            currency: 'USD',
            category: 'Travelling',
            categoryType: 'Home',
            status: 'Delivered',
            statusClass: 'text-bg-success',
            deliverTo: 'John Doe',
            address: '2356, Street-5, New York 4586, US',
            location: 'Lat: 5.678167, Long: 12.078613',
            locationNote: 'This can be a map also',
            payment: 'Waiting',
            paymentClass: 'bg-theme-1 theme-blue'
        },
        {
            icon: { type: 'image', src: asset('assets/img/adminuiux/image-2.jpg') },
            name: 'Bus Service',
            subtitle: 'Round Trip',
            amount: '251.00',
            currency: 'USD',
            category: 'Travelling',
            categoryType: 'Home',
            status: 'Pending',
            statusClass: 'text-bg-theme-1 theme-orange',
            deliverTo: 'John Doe',
            address: '2356, Street-5, New York 4586, US',
            location: 'Lat: 5.678167, Long: 12.078613',
            locationNote: 'This can be a map also',
            payment: 'Waiting',
            paymentClass: 'bg-theme-1 theme-blue'
        },
        {
            icon: { type: 'image', src: asset('assets/img/adminuiux/image-1.jpg') },
            name: 'Zomaatos',
            subtitle: 'Meal',
            amount: '12.00',
            currency: 'USD',
            category: 'Food',
            categoryType: 'Work',
            status: 'Delivered',
            statusClass: 'text-bg-success',
            deliverTo: 'John Doe',
            address: '2356, Street-5, New York 4586, US',
            location: 'Lat: 5.678167, Long: 12.078613',
            locationNote: 'This can be a map also',
            payment: 'Paid',
            paymentClass: 'bg-green'
        }
    ], []);
    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Earning</h6>
                        <p className="text-secondary small">Earning summary helps you to grow more...</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi"><Link to="/app/my-profile"> My Profile</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page"> Earning</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">

                <div className="row gx-3 gx-lg-4">
                    <div className="col-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="avatar avatar-60 text-center rounded bg-theme-1-subtle text-theme-1 mb-3 theme-cyan"><i className="bi bi-wallet h4"></i></div>
                                <h4 className="mb-0">$ 980.00</h4>
                                <p className="text-secondary small">Current Account Balance</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="avatar avatar-60 text-center rounded bg-theme-1-subtle text-theme-1 mb-3 theme-green"><i className="bi bi-cash-stack h4"></i></div>
                                <h4 className="mb-0">$ 2820.00</h4>
                                <p className="text-secondary small">Total Total Earning <span className="text-success">4% <i className="bi bi-arrow-up"></i></span></p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="avatar avatar-60 text-center rounded bg-theme-1-subtle text-theme-1 mb-3 theme-yellow"><i className="bi bi-hourglass-bottom h4"></i></div>
                                <h4 className="mb-0">$ 645.00</h4>
                                <p className="text-secondary small">Payment Pending</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="avatar avatar-60 text-center rounded bg-theme-1-subtle text-theme-1 mb-3"><i className="bi bi-calendar-week h4"></i></div>
                                <h4 className="mb-0">$ 980.00</h4>
                                <p className="text-secondary small">Next 2 July 2024</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-lg-9">
                        <div className="card overflow-hidden mb-3 mb-lg-4">
                            <div className="card-header">
                                <h6 className="mb-0">Earning Statistics</h6>
                                <p className="small"><span className="text-secondary">Total money received as income source</span></p>
                            </div>
                            <div className="card-body">
                                <div className="height-260 mb-3">
                                    <AreaChart labels={['1 Feb', '2 Feb', '3 Feb', '4 Feb', '5 Feb', '6 Feb', '7 Feb', '8 Feb', '9 Feb', '10 Feb']}
                                        datasets={[
                                            {
                                                data: [15, 10, 30, 15, 12, 10, 20, 15, 25, 20,],
                                                label: 'Female',
                                                color: '#e563ad',
                                                fillColor: 'rgba(229, 116, 173, 0.5)',
                                                borderWidth: 1,
                                                pointBackgroundColor: '#e563ad',
                                                pointBorderColor: '#ffffff',
                                                pointRadius: 2,
                                                tension: 0.4,
                                                borderColor: '#e563ad',
                                            },
                                            {
                                                data: [20, 15, 15, 10, 20, 15, 25, 20, 10, 30],
                                                label: 'Male',
                                                color: '#9c63f7',
                                                fillColor: 'rgba(156, 99, 247, 0.5)',
                                                borderWidth: 1,
                                                pointBackgroundColor: '#9c63f7',
                                                pointBorderColor: '#ffffff',
                                                pointRadius: 2,
                                                tension: 0.4,
                                                borderColor: '#9c63f7',
                                            },
                                        ]}
                                        scalesx={true}
                                        scalesy={true}
                                        height={260} />
                                </div>
                                <div className="row gx-3 align-items-center">
                                    <div className="col-6 col-md-6 col-lg-4 col-xl-3 mb-1">
                                        <h4 className="mb-1">$5560.50</h4>
                                        <p className="small text-secondary">Earning <span className="text-success"><i className="bi bi-arrow-up"></i> 11.5%</span></p>
                                    </div>
                                    <div className="col-6 col-md-6 col-lg-4 col-xl-3 mb-1">
                                        <h4 className="mb-1">$4146.50</h4>
                                        <p className="small text-secondary">Last Duration <span className="text-success"><i className="bi bi-arrow-up"></i> 3.65%</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-3">
                        <div className="card overflow-hidden mb-3 mb-lg-4">
                            <div className="card-header">
                                <h6 className="mb-0">Expense by Category</h6>
                                <p className="small"><span className="text-secondary">Payments for bills and salaries</span></p>
                            </div>
                            <div className="card-body pb-0">
                                <div className="height-140 w-100 position-relative text-center mb-2">
                                    <div className="position-absolute bottom-0 mx-auto start-50 translate-middle">
                                        <p className="text-secondary small mb-0">Total Expense</p>
                                        <h5>5.4k <small>USD</small></h5>
                                    </div>
                                    <div className="width-200 height-200 d-inline-flex justify-content-center align-items-center mt--25 position-relative">
                                        <DoughnutChart
                                            labels={['Salary', 'Electricity', 'Food', 'Transport']}
                                            data={[10, 15, 25, 10]}
                                            colors={['#3ee782', '#fb38b4ff', '#9c63f7ff', '#2ebeefff']}
                                            cutout="80%"
                                            circumference={180}
                                            rotation={-90}
                                            height={140}
                                        />
                                    </div>
                                </div>
                                <div className="row gx-3">
                                    <div className="col-6 col-md-6 mb-4">
                                        <p className="text-secondary small mb-2"><span className="me-1 avatar avatar-10 rounded bg-teal"></span> Salary</p>
                                        <h5 className="ps-3">$ 165.52k <span className="text-success fs-14 fw-normal"><i className="bi bi-caret-up-fill me-1 fs-14"></i> 25.30%</span></h5>
                                    </div>
                                    <div className="col-6 col-md-6 mb-4">
                                        <p className="text-secondary small mb-2"><span className="me-1 avatar avatar-10 rounded bg-pink"></span> Electricity</p>
                                        <h5 className="ps-3">$ 265.85k <span className="text-success fs-14 fw-normal"><i className="bi bi-caret-up-fill me-1"></i> 21.42%</span></h5>
                                    </div>
                                    <div className="col-6 col-md-6 mb-4">
                                        <p className="text-secondary small mb-2"><span className="me-1 avatar avatar-10 rounded bg-purple"></span> Food</p>
                                        <h5 className="ps-3">$ 356.26k <span className="text-success fs-14 fw-normal"><i className="bi bi-caret-up-fill me-1"></i> 20.18%</span></h5>
                                    </div>
                                    <div className="col-6 col-md-6 mb-4">
                                        <p className="text-secondary small mb-2"><span className="me-1 avatar avatar-10 rounded bg-cyan"></span> Maintenance</p>
                                        <h5 className="ps-3">$ 185.65 <span className="text-success fs-14 fw-normal"><i className="bi bi-caret-up-fill me-1"></i> 15.65%</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Grid table*/}
                <div className="card mb-3 mb-lg-4">
                    <div className="card-header">
                        <div className="row gx-3">
                            <div className="col-12 col-md align-self-center mb-3 mb-lg-0">
                                <h6 className="mb-1">Transactions</h6>
                                <p className="text-secondary small mb-0">Recent transaction made</p>
                            </div>
                            <div className="col-6 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
                                <select className="form-select">
                                    <option>All Categories</option>
                                    <optgroup label="Food">
                                        <option>- Work</option>
                                        <option>- Home</option>
                                    </optgroup>
                                    <optgroup label="Children">
                                        <option>- Fees</option>
                                        <option>- Enjoyment</option>
                                    </optgroup>
                                    <optgroup label="Transportation">
                                        <option>- Personal</option>
                                        <option>- Work</option>
                                    </optgroup>
                                    <optgroup label="Home">
                                        <option>- Rent</option>
                                        <option>- Maintenance</option>
                                    </optgroup>
                                    <option>Personal</option>
                                    <option>Other</option>
                                </select>
                            </div>
                            <div className="col-6 col-md-auto ms-auto">
                                <div className="input-group ">
                                    <span className="input-group-text text-theme-1"><i className="bi bi-search"></i></span>
                                    <input type="text" className="form-control" placeholder="Search..." />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body pt-0">
                        <DataTable
                            options={options}
                            className="table"
                            id="dataTable"
                        >
                            <thead>
                                <tr>
                                    <th className="width-10"></th>
                                    <th className="all">Expense</th>
                                    <th className="tablet desktop">Amount</th>
                                    <th className="desktop">Category</th>
                                    <th className="tablet">Status</th>
                                    <th className="desktop">Deliver to</th>
                                    <th className="none">Address</th>
                                    <th className="none">Location</th>
                                    <th className="tablet desktop">Payment</th>
                                    <th className="all">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactionsData.map((transaction, index) => (
                                    <tr key={index}>
                                        <td></td>
                                        <td>
                                            <div className="row gx-3 gx-lg-4 align-items-center">
                                                <div className="col-auto">
                                                    {transaction.icon.type === 'icon' ? (
                                                        <div className={`avatar avatar-40 mb-0 coverimg rounded-circle ${transaction.icon.bgClass}`}>
                                                            <i className={`bi ${transaction.icon.class}`}></i>
                                                        </div>
                                                    ) : (
                                                        <figure className="avatar avatar-40 mb-0 bg-theme-1 coverimg rounded-circle">
                                                            <img src={asset(`${transaction.icon.src}`)} alt="" />
                                                        </figure>
                                                    )}
                                                </div>
                                                <div className="col">
                                                    <p className="mb-0">{transaction.name}</p>
                                                    <p className="text-secondary small">{transaction.subtitle}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <p className="mb-0">{transaction.amount}</p>
                                            <p className="text-secondary small">{transaction.currency}</p>
                                        </td>
                                        <td>
                                            <p className="mb-0">{transaction.category}</p>
                                            <p className="text-secondary small">{transaction.categoryType}</p>
                                        </td>
                                        <td>
                                            <span className={`badge badge-sm badge-light ${transaction.statusClass}`}>{transaction.status}</span>
                                        </td>
                                        <td>
                                            {transaction.deliverTo}
                                        </td>
                                        <td>
                                            {transaction.address}
                                        </td>
                                        <td>
                                            <p className="mb-1">{transaction.location}</p>
                                            <p className="text-secondary small">{transaction.locationNote}</p>
                                        </td>
                                        <td>
                                            <span className={`badge rounded-5 ${transaction.paymentClass}`}>{transaction.payment}</span>
                                        </td>
                                        <td>
                                            <div className="dropdown d-inline-block">
                                                <a className="text-secondary no-caret" data-bs-toggle="dropdown" aria-expanded="false" data-bs-display="static" role="button">
                                                    <i className="bi bi-three-dots"></i>
                                                </a>
                                                <ul className="dropdown-menu dropdown-menu-end">
                                                    <li><a className="dropdown-item" href="javascript:void(0)">Edit</a></li>
                                                    <li><a className="dropdown-item" href="javascript:void(0)">Move</a></li>
                                                    <li><a className="dropdown-item text-danger" href="javascript:void(0)">Delete</a></li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Earning;
